export const DROPDOWN_LIST = {
  PRODUCTS: [
    {
      heading: 'CAP',
      subHeading: 'Full-time PM Jobs',
      color: '#FF7504',
      url: 'https://upraised.co/career-accelerator-program',
      linkTitle: 'Career Accelerator Program',
    },
    {
      heading: 'Preppa',
      subHeading: 'Interview Preparation',
      color: '#0C7BEB',
      url: 'https://upraised.co/preppa',
      linkTitle: 'Preppa',
    },
    // {
    //   heading: 'Embark',
    //   subHeading: 'Internships with Stipend',
    //   color: '#8F44FF',
    //   url: 'https://upraised.co/embark',
    //   linkTitle: 'Embark',
    // },
    {
      heading: 'KYS',
      subHeading: 'Know Your Self Test',
      color: '#11A85A',
      url: 'https://upraised.co/kys-know-yourself-test',
      linkTitle: 'Know Your Self Test',
    },
  ],
  RESOURCES: [
    {
      heading: 'Blog',
      url: 'https://upraised.co/blog',
      linkTitle: 'Blogs',
    },
    {
      heading: 'Live Events',
      url: 'https://upraised.co/events',
      linkTitle: 'Live Events',
    },
    {
      heading: 'PM Resources',
      url: 'https://upraised.co/free-product-management-course',
      linkTitle: 'PM Resources',
    },
    {
      heading: 'CAP ROI Calculator',
      url: 'https://upraised.co/cap/roi',
    },
  ],
  HIRE: [
    {
      heading: 'Hire Full Time',
      url: 'https://upraised.co/post-a-job',
      linkTitle: 'Hire Full Time',
    },
    {
      heading: 'Hire Interns',
      url: 'https://upraised.co/embark/hire-interns',
      linkTitle: 'Hire Interns',
    },
  ],
  IMPACT: [
    {
      heading: 'Success Stories',
      url: 'https://upraised.co/alumni',
      linkTitle: 'Success Stories',
    },
    // {
    //   heading: 'Placement Report',
    //   url: 'https://upraised.co/placement-report',
    //   linkTitle: 'Placement Report',
    // },
  ],
};
